import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { utils } from '../../../helper/utils';

export const RepairCodeExclusionListGridColumns: Array<TableColumn> = [
  { id: 'repairMode', label: 'Mode', sortDisabled: true, width: '70px' },
  {
    id: 'repairCode',
    label: 'Repair Code',
    width: '120px',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        return stringValue || '';
      },
    },
  },
  { id: 'description', label: 'Description', sortDisabled: true, width: '260px' },
  { id: 'exclusiveRepairCodes', label: 'Exclusive Repair Codes', sortDisabled: true, width: '280px' },
  { id: 'updatedBy', label: 'Updated By', sortDisabled: true, width: '180px' },
  {
    id: 'updatedAt',
    label: 'Last Updated',
    sortDisabled: true,
    width: '180px',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const stringValue = value as string;
        if (!stringValue) {
          return '';
        }
        const date = new Date(stringValue);
        return Number.isNaN(date.getTime()) ? stringValue : utils.dateFormatter.format(date);
      },
    },
  },
  { id: 'actions', label: '', sortDisabled: true, width: '90px' },
];
